import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EquipmentLocationFormOptions } from "../../interfaces";

/**
 * Creates a feature selector for the 'equipmentLocationForm' Feature.
 * @param {string} featureName The name of the feature.
 * @returns {import('@ngrx/store').MemoizedSelector<object, InformationData>} A
 * memoized selector that returns the 'equipmentLocationForm' feature state.
 * 
 * @const equipmentLocationFormFeature
 */
export const equipmentLocationFormFeature = createFeatureSelector<EquipmentLocationFormOptions>('equipmentLocationForm');

export const getEquipmentLocationData = (data: EquipmentLocationFormOptions): EquipmentLocationFormOptions => data;

export const getEquipmentLocationFormDataSelector = createSelector(
    equipmentLocationFormFeature,
    getEquipmentLocationData
);